<template>
  <div>
    <tableTemplate
      :columns="columns"
      :searchForm="searchForm"
      :apiUrl="apiUrl"
      @initSearch="initSearch"
    >
      <!-- <div slot="searchBtns">xx</div> -->
      <!-- <div slot="toolBtns">
      <Button type="primary">新增</Button>
      </div>-->
      <!-- 自定义组件通过dispatch触发表单验证 -->
      <template slot-scope="{row,index,slots}" slot="myNames">
        <div>
          <input
            v-model="row.value"
            style="border:1px solid #ddd"
            @input="slots.dispatch('FormItem', 'on-form-change')"
          />
        </div>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <div class="detail">
          <div @click="showEdit(row)">编辑</div>
          <div @click="toShowQus(row)">题目配置</div>
          <div @click="dele(row)">删除</div>
        </div>
      </template>
    </tableTemplate>
  </div>
</template>
<script>
import tableTemplate from "@/components/commons/tableBaseTemplate";
export default {
  components: {
    tableTemplate
  },
  data() {
    return {
      test: "",
      apiUrl: "/buz/actionLog/read/list",
      columns: [
        {
          title: "姓名",
          key: "userName",
          align: "center",
          ellipsis: true,
          tooltip: true
        },
        {
          title: "手机号",
          key: "mobile",
          align: "center"
        },
        {
          title: "行为名称",
          key: "sign",
          align: "center",
          ellipsis: true,
          tooltip: true
        },
        {
          title: "行为时间 ",
          key: "actionTime",
          align: "center",
          minWidth: 160,
        },
        {
          title: "操作 ",
          slot: "action",
          align: "center"
        }
      ],
      searchForm: [
        {
          name: "姓名",
          key: "userName",
          value: "",
          type: -1,
          clearable: true,
          slot: "myNames",
          rules: [
            {
              required: true,
              message: "请输入"
            }
          ]
        },
        {
          name: "手机号",
          key: "mobile",
          value: "",
          type: -1,
          clearable: true,
          rules: [
            {
              required: true,
              message: "请输入"
            }
          ],
          render(h, item) {
            return (
              <input
                vModel={item.value}
                onInput={e => this.dispatch("FormItem", "on-form-change")}
              />
            );
          }
        },
        {
          name: "行为名称",
          key: "sign",
          value: "",
          type: 2,

          arr: this.analyList,
          clearable: true
        },
        {
          name: "行为时间",
          key: "actionTime",
          dateType: "daterange",
          value: "",
          type: 3,
          clearable: true
        }
      ]
    };
  },
  methods: {
    initSearch(obj) {
      if (obj.actionTime) {
        obj.startTime = obj.actionTime[0];
        obj.endTime = obj.actionTime[1];
        delete obj.actionTime;
      }
    }
  }
};
</script>
